<div class="authentication-container" [class.bg-cb]="isCasasBahia" [class.bg-pf]="!isCasasBahia">
  <div *ngIf="!isCasasBahia" class="mobile-header">
    <img class="brand-maskot" [src]="assets.brandMascot" alt="Logo ViaVarejo" />
    <img class="brand" [src]="assets.brandVert" alt="Logo ViaVarejo" />
  </div>
  
  <div *ngIf="!isCasasBahia" class="desktop-header">
    <div class="desktop-header-content">
      <img class="brand" [src]="assets.brand" alt="Logo ViaVarejo" />
    </div>
  </div>

  <div *ngIf="isCasasBahia" class="cb-header-container">
    <div class="cb-header-content">
      <a routerLink="/" class="brand-container">
        <img src="assets/images/new-brand-cb-text.svg">
        <hr>
      </a>
  
      <a routerLink="/"  class="brand-name-container">
        <div class="brand-name">
          <h1>Pagamento e renegociação</h1>
          <h2>Carnê e cartão</h2>
        </div>
      </a>
    </div>
  </div>
  
  <div class="card-container">
    <div class="card-content">
      <img *ngIf="!isCasasBahia" class="brand-maskot" [src]="assets.brandMascot" alt="Logo ViaVarejo" />

      <div class="login-card" [class.isOldFirefox]="isOldFirefox" [class.isColaboradorLogado]="colaboradorLogado">
        <div class="login-header">
          <h2 *ngIf="!colaboradorLogado">Login colaborador</h2>
          <h2 *ngIf="colaboradorLogado">Iniciar atendimento</h2>
          <h4>{{ colaboradorLogado ? 'Informe os dados do cliente:' : 'Acesse sua conta:' }}</h4>
        </div>
      
        <app-colaborador-authentication-form
          *ngIf="!colaboradorLogado"
          [loading]="loader" 
          (login)="loginColaborador($event)">
        </app-colaborador-authentication-form>
      
        <app-usuario-authentication-form
          (login)="loginUsuario($event)"
          (logout)="logoutColaborador()"
          [loading]="loader" 
          *ngIf="colaboradorLogado">
        </app-usuario-authentication-form>
      </div>
    </div>
  </div>
</div>